import medicinesImg from "../../assets/newIcons/Medicine.svg";
import medicinesActiveImg from "../../assets/newIcons/Medicine Active.svg";
import invImg from "../../assets/newIcons/Investigation.svg";
import activeInvImg from "../../assets/newIcons/Investigation Active.svg";
import iaImg from "../../assets/newIcons/Initial Assessment.svg";
import activeIa from "../../assets/newIcons/Initial Assessment Active.svg";
import steth from "../../assets/newIcons/stethoscope.svg";
import stethActive from "../../assets/newIcons/stethoscope  Active.svg";
import nurseImg from "../../assets/newIcons/Care Items.svg";
import nurseActiveImg from "../../assets/newIcons/Care Items Active.svg";
import heart from "../../assets/newIcons/Monitoring.svg";
import heartActive from "../../assets/newIcons/Monitoring Active.svg";
import diet from "../../assets/newIcons/Diet.svg";
import dietActive from "../../assets/newIcons/Diet Active.svg";
import progressImg from "../../assets/newIcons/Progress Notes.svg";
import activeProgressImg from "../../assets/newIcons/Progress Notes Active.svg";
import gallery from "../../assets/newIcons/gallery 1.svg";
import galleryActive from "../../assets/newIcons/gallery 1 Active.svg";
import packages from "../../assets/newIcons/PAckage.svg";
import packagesActive from "../../assets/newIcons/PAckage Active.svg";
import bedManagement from "../../assets/newIcons/hospital-bed 2.svg";
import bedActive from "../../assets/newIcons/hospital-bed 2 Active.svg";
import services from "../../assets/newIcons/Services.svg";
import serviceActive from "../../assets/newIcons/Services Active.svg";
import activeBilling from "../../assets/newIcons/bill 3 Active.svg";
import billingMenu from "../../assets/newIcons/bill 3.svg";
import physioCareImg from "../../assets/newIcons/Physio Care.svg";
import physioCareActiveImg from "../../assets/newIcons/Physio Care Active.svg";
import mcInActiveImg from "../../assets/newIcons/monitoring Chart.svg";
import mcActive from "../../assets/newIcons/monitoring Chart Active.svg";
import { Image, Tooltip } from "antd";
import progressScaleImg from "../../assets/newIcons/Progress Scale.svg";
import progressScaleActive from "../../assets/newIcons/Progress Scale Active.svg";
import chatImg from "../../assets/newIcons/Chat.svg";
import chatActive from "../../assets/newIcons/Chat Active.svg";
import SummaryIcon from "../../assets/newIcons/SUmmary.svg";
import SummaryIconActive from "../../assets/newIcons/SUmmary Active.svg";
export const getuserRoleTabs = (ROLE, tab, token, options = {}) => {
  const {
    hideTooltips = false,
    compactIcons = false,
    clinicalForms = [],
  } = options;

  // Classification by code (mirrors useClinicalRoleForms):
  //   IA     = code === "initial_assessment"
  //   Review = code === "review_form" | "review"
  //   Other  = everything else (rendered under the Forms dropdown)
  // clinicalForms arrives pre-sorted by id ascending from PatientMenu.
  const IA_CODE = "initial_assessment";
  const REVIEW_CODES = new Set(["review_form", "review"]);
  const iaForm =
    ROLE === "Clinical_Practitioner"
      ? clinicalForms.find((f) => f?.code === IA_CODE) || null
      : null;
  const reviewForm =
    ROLE === "Clinical_Practitioner"
      ? clinicalForms.find((f) => REVIEW_CODES.has(f?.code)) || null
      : null;
  const dynamicOtherForms = (clinicalForms || []).filter(
    (f) => f?.code !== IA_CODE && !REVIEW_CODES.has(f?.code)
  );
  const practitionerOtherForms =
    ROLE === "Clinical_Practitioner" ? dynamicOtherForms : [];
  const showForms =
    ROLE === "Clinical_Practitioner"
      ? practitionerOtherForms.length > 0
      : true;
  const dynamicFormItems = dynamicOtherForms.map((f) => ({
    label: f.name,
    key: `clinical-form-${f.id}`,
  }));
  const activeStyles = {
    height: compactIcons ? "42px" : "50px",
    width: "auto",
    marginBottom: compactIcons ? "4px" : "8px",
    background: token.colorPrimary,
    padding: compactIcons ? "8px" : "10px",
    borderRadius: "6px",
  };
  const styles = {
    height: compactIcons ? "42px" : "50px",
    width: "auto",
    marginBottom: compactIcons ? "4px" : "8px",
    background: "#fff",
    padding: compactIcons ? "8px" : "10px",
    borderRadius: "6px",
    border: "1px solid #D9D9D9",
  };

  const allRoles = [
    "Doctor",
    "Nurse",
    "Speech_Swallow_Therapist",
    "Respiratory_Therapist",
    "Nutritionist",
    "Physiotherapist",
    "Psychologist",
    "Receptionist",
    "Clinical_Practitioner",
  ];
  const practitionerRoles = [
    "Doctor",
    "Nurse",
    "Speech_Swallow_Therapist",
    "Respiratory_Therapist",
    "Nutritionist",
    "Physiotherapist",
    "Psychologist",
  ];

  const menuImages = (icon, styles, title) => {
    const iconNode = (
      <span
        role="img"
        aria-label={title}
        className="anticon anticon-user ant-menu-item-icon"
      >
        <Image src={icon} preview={false} style={styles} />
      </span>
    );

    if (hideTooltips) return iconNode;

    return (
      <Tooltip title={title} trigger={["hover"]} mouseEnterDelay={0.15}>
        {iconNode}
      </Tooltip>
    );
  };
  const roleSpecificItems = {
    Doctor: [
      "landing",
      "logs",
      "ia",
      "review",
      "order-sheet",
      "medicine",
      "chat",
      "monitoring",
    ],
    Physiotherapist: [
      "ia",
      "review",
      "progress-scales",
      "physio-care",
      "medicine",
      "chat",
    ],
    Nutritionist: ["ia", "risk_assessment", "chat"],
    Nurse: [
      "landing",
      "order-sheet",
      "ia",
      "medicine",
      "chat",
      "monitoring",
      "services",
    ],
    Speech_Swallow_Therapist: ["ia", "review", "medicine", "chat"],
    Respiratory_Therapist: ["ia", "review", "chat"],
    Receptionist: [
      "packages",
      "bed-management",
      "services",
      "billing",
      "gallery",
      "forms",
    ],
    Psychologist: ["ia", "review", "medicine", "chat"],
    Clinical_Practitioner: [
      ...(iaForm ? ["ia"] : []),
      ...(reviewForm ? ["review"] : []),
      "diet",
      "progress_monitoring",
      "gallery",
      "monitoring-charts",
      "medicine",
      "forms",
    ],
  };

  const allItems = [
    {
      label:
        tab === "billing"
          ? menuImages(activeBilling, activeStyles, "Billing")
          : menuImages(billingMenu, styles, "Billing"),
      key: "billing",
    },
    ...(ROLE === "Receptionist"
      ? [
          {
            label:
              tab === "services"
                ? menuImages(serviceActive, activeStyles, "Services")
                : menuImages(services, styles, "Services"),
            key: "services",
          },
        ]
      : []),

    {
      label:
        tab === "packages"
          ? menuImages(packagesActive, activeStyles, "Packages")
          : menuImages(packages, styles, "Packages"),
      key: "packages",
    },
    {
      label:
        tab === "bed-management"
          ? menuImages(bedActive, activeStyles, "Bed Management")
          : menuImages(bedManagement, styles, "Bed Management"),
      key: "bed-management",
    },

    {
      label:
        tab === "landing"
          ? menuImages(SummaryIconActive, activeStyles, "Summary")
          : menuImages(SummaryIcon, styles, "Summary"),
      key: "landing",
    },
    // {
    //   label:
    //     tab === "logs"
    //       ? menuImages(activeLogImg, activeStyles, "Activity")
    //       : menuImages(logImg, styles, "Activity"),
    //   key: "logs",
    // },
    {
      label:
        tab === "ia"
          ? menuImages(activeIa, activeStyles, "Initial Assessment")
          : menuImages(iaImg, styles, "Initial Assessment"),
      key: "ia",
    },
    {
      label:
        tab === "review"
          ? menuImages(stethActive, activeStyles, "Review")
          : menuImages(steth, styles, "Review"),
      key: "review",
    },
    {
      label:
        tab === "progress-scales"
          ? menuImages(progressScaleActive, activeStyles, "Progress Scales")
          : menuImages(progressScaleImg, styles, "Progress Scales"),
      key: "progress-scales",
    },
    {
      label:
        tab === "risk_assessment"
          ? menuImages(stethActive, activeStyles, "Risk Assessment")
          : menuImages(steth, styles, "Risk Assessment"),
      key: "risk_assessment",
    },
    {
      label:
        tab === "physio-care"
          ? menuImages(physioCareActiveImg, activeStyles, "Physio Care")
          : menuImages(physioCareImg, styles, "Physio Care"),
      key: "physio-care",
    },
    {
      label:
        tab === "medicine"
          ? menuImages(medicinesActiveImg, activeStyles, "Medicine")
          : menuImages(medicinesImg, styles, "Medicine"),
      key: "medicine",
    },
    {
      label:
        tab === "investigations"
          ? menuImages(activeInvImg, activeStyles, "Investigations")
          : menuImages(invImg, styles, "Investigations"),
      key: "investigations",
    },

    {
      label:
        tab === "order-sheet"
          ? menuImages(nurseActiveImg, activeStyles, "Care Items")
          : menuImages(nurseImg, styles, "Care Items"),
      key: "order-sheet",
    },
    ...(ROLE === "Nurse"
      ? [
          {
            label:
              tab === "services"
                ? menuImages(serviceActive, activeStyles, "Services")
                : menuImages(services, styles, "Services"),
            key: "services",
          },
        ]
      : []),

    {
      label:
        tab === "diet"
          ? menuImages(dietActive, activeStyles, "Diet")
          : menuImages(diet, styles, "Diet"),
      key: "diet",
    },
    {
      label:
        tab === "progress_monitoring"
          ? menuImages(activeProgressImg, activeStyles, "Progress Notes")
          : menuImages(progressImg, styles, "Progress Notes"),
      key: "progress_monitoring",
    },
    {
      label:
        tab === "chat"
          ? menuImages(chatActive, activeStyles, "Chat")
          : menuImages(chatImg, styles, "Chat"),
      key: "chat",
    },
    {
      label:
        tab === "monitoring"
          ? menuImages(heartActive, activeStyles, "Vital Monitoring")
          : menuImages(heart, styles, "Vital Monitoring"),
      key: "monitoring",
    },
    {
      label:
        tab === "gallery"
          ? menuImages(galleryActive, activeStyles, "Gallery")
          : menuImages(gallery, styles, "Gallery"),
      key: "gallery",
    },
    {
      label:
        tab === "monitoring-charts"
          ? menuImages(mcActive, activeStyles, "Monitoring Charts")
          : menuImages(mcInActiveImg, styles, "Monitoring Charts"),
      key: "monitoring-charts",
    },

    ...(showForms
      ? [
          {
            label: "Forms",
            key: "forms",
            children: [
              ...(ROLE === "Clinical_Practitioner"
                ? practitionerOtherForms.map((f) => ({
                    label: f.name,
                    key: `clinical-form-${f.id}`,
                  }))
                : ROLE === "Receptionist"
                ? [
                    {
                      label: "Discharge Summary",
                      key: "discharge-summary",
                    },
                    {
                      label: "EMR Download",
                      key: "emr-download",
                    },
                    {
                      label: "Referral Form",
                      key: "referral-form",
                    },
                    {
                      label: "Death Summary",
                      key: "death-summary",
                    },
                    {
                      label: "Investigation Referral Form",
                      key: "investigation-referral-form",
                    },
                    {
                      label: "Review Forms",
                      key: "review-forms",
                    },
                    {
                      label: "Emergency Shift Form",
                      key: "emergency-shift-form",
                    },
                  ]
                : ROLE === "Nurse"
                ? [
                    {
                      label: "Discharge Summary",
                      key: "discharge-summary",
                    },
                    ...dynamicFormItems,
                  ]
                : [
                    ...(ROLE === "Nutritionist"
                      ? [
                          {
                            label: "Nutritionist Reassessment Form",
                            key: "nutritionist-reassessment",
                          },
                        ]
                      : /* Referral, Death, Investigation and the doctor's
                           Review Form are the doctor's to raise. These roles
                           were being offered them only because they fell
                           through to the list below, and opening one called a
                           doctor endpoint that answers 404/400 for them. They
                           keep the discharge summary to read, and their own
                           clinical forms are appended after this. */
                      [
                          "Respiratory_Therapist",
                          "Psychologist",
                          "Speech_Swallow_Therapist",
                        ].includes(ROLE)
                      ? [
                          {
                            label: "Discharge Summary",
                            key: "discharge-summary",
                          },
                        ]
                      : ROLE === "Physiotherapist"
                      ? [
                          {
                            label: "Discharge Summary",
                            key: "discharge-summary",
                          },
                          {
                            label: "Review Forms",
                            key: "review-forms",
                          },
                        ]
                      : [
                          {
                            label: "Discharge Summary",
                            key: "discharge-summary",
                          },
                          {
                            label: "Referral Form",
                            key: "referral-form",
                          },
                          {
                            label: "Death Summary",
                            key: "death-summary",
                          },
                          {
                            label: "Investigation Referral Form",
                            key: "investigation-referral-form",
                          },
                          {
                            label: "Review Forms",
                            key: "review-forms",
                          },
                          // Raising an emergency shift is a doctor's call, so
                          // only the doctor's EMR offers it among the
                          // practitioner roles. The receptionist gets it in
                          // their own branch above, read-only, to print and
                          // share the raised form.
                          ...(ROLE === "Doctor"
                            ? [
                                {
                                  label: "Emergency Shift Form",
                                  key: "emergency-shift-form",
                                },
                              ]
                            : []),
                        ]),
                    ...dynamicFormItems,
                  ]),
            ],
          },
        ]
      : []),

    {
      label: "Other EMRs",
      key: "emr",
      children: practitionerRoles
        .filter((role) => role !== ROLE)
        .map((role) => ({
          label: role.replace(/_/g, " "),
          key: role.toLowerCase(),
        })),
    },
  ];

  const TAB_TITLES = {
    billing: "Billing",
    services: "Services",
    packages: "Packages",
    "bed-management": "Bed Management",
    landing: "Summary",
    ia: "Initial Assessment",
    review: "Review",
    "progress-scales": "Progress Scales",
    risk_assessment: "Risk Assessment",
    "physio-care": "Physio Care",
    medicine: "Medicine",
    investigations: "Investigations",
    "order-sheet": "Care Items",
    diet: "Diet",
    progress_monitoring: "Progress Notes",
    chat: "Chat",
    monitoring: "Vital Monitoring",
    gallery: "Gallery",
    "monitoring-charts": "Monitoring Charts",
    forms: "Forms",
    emr: "Other EMRs",
  };

  const rolesWithExplicitTabsOnly = ["Receptionist", "Clinical_Practitioner"];

  const getFilteredItems = (role) => {
    const roleItems = roleSpecificItems[role] || [];

    const items = !rolesWithExplicitTabsOnly.includes(ROLE)
      ? [
          ...allItems.filter((item) => roleItems.includes(item.key)),
          ...allItems.filter((item) =>
            [
              "investigations",
              "forms",
              "diet",
              "progress_monitoring",
              "monitoring-charts",
              "gallery",
            ].includes(item.key)
          ),
          allItems.find((item) => item.key === "emr"),
        ]
      : [...allItems.filter((item) => roleItems.includes(item.key))];

    return items.filter(Boolean).map((item) => {
      const name = TAB_TITLES[item.key] || item.key;
      return {
        ...item,
        tabTitle: name,
        title: hideTooltips ? name : null,
      };
    });
  };

  return getFilteredItems(ROLE);
};
